'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports['default'] = void 0;
var _propTypes = _interopRequireDefault(require('prop-types'));
var _error = _interopRequireDefault(require('@vds-core/icons/error'));
var _react = _interopRequireDefault(require('react'));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : { default: e };
}
var propTypes = {
  /**
   * Option to render on dark or light surface
   */
  surface: _propTypes['default'].oneOf(['light', 'dark']),
};
var defaultProps = {
  surface: 'light',
};
var Error = function Error(props) {
  return /*#__PURE__*/ _react['default'].createElement(
    _error['default'],
    props
  );
};
Error.propTypes = propTypes;
Error.defaultProps = defaultProps;
Error.displayName = 'VDS_Icon';
var _default = (exports['default'] = Error);
